var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-device-test-list" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-info" }, [
        _c("div", { staticClass: "header-title" }, [_vm._v("设备列表")]),
        _c("div", { staticClass: "header-count" }, [
          _vm._v(
            "共检测到" + _vm._s(_vm.list.length) + "台，当前展示IMEI后六位"
          )
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "header-refresh-btn",
          on: { click: _vm.onclickRefreshBtn }
        },
        [_vm._v("刷 新")]
      )
    ]),
    _c(
      "div",
      { staticClass: "list" },
      _vm._l(_vm.list, function(item, index) {
        return _c("div", { key: index, staticClass: "item" }, [
          _c("div", { staticClass: "item-left" }, [
            _c("img", {
              staticClass: "icon-feeder",
              attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
            }),
            _c("div", { staticClass: "item-num" }, [
              _vm._v(_vm._s(item.displayNum))
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "item-btn",
              on: {
                click: function($event) {
                  return _vm.onclickTestBtn(index)
                }
              }
            },
            [_vm._v("测试")]
          )
        ])
      }),
      0
    ),
    !_vm.list.length
      ? _c("div", { staticClass: "list-tip" }, [
          _vm._v("暂无设备，请将设备通电")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }